import type { Locale } from "../schema/Locale.js";
import { appDateTimeZone } from "../schema/appDateTimeZone.js";
import { printDateFormat } from "./printDateFormat.js";

const formatCache: Partial<Record<Locale, Intl.DateTimeFormat>> = {};
function createFormat(locale: Locale): Intl.DateTimeFormat {
	formatCache[locale] ??= new Intl.DateTimeFormat(locale, {
		day: "numeric",
		month: "numeric",
		year: "numeric",
		timeZone: appDateTimeZone,
	});
	return formatCache[locale];
}

export function toDateMonthYearFormat(date: undefined | number | string | Date, locale: Locale): string {
	if (date === undefined) {
		return printDateFormat(createFormat(locale));
	}
	return createFormat(locale).format(typeof date === "string" ? new Date(date) : date);
}
